<div class="action-list-header">
    <h3 i18n>Actions</h3>
</div>
<mat-list>
    <mat-list-item class="action-list-item"
                   *ngFor="let action of actions; first as isFirst"
                   [class.mt-4]="!isFirst"
                   lines="3">
        <span matListItemTitle class="small"><strong>{{ action.name }}</strong></span>
        <span class="text-muted small">{{ action.description }}</span>
        <button mat-icon-button
                [attr.aria-label]="getCreateButtonTitle(action.name)"
                (click)="onEdit(action.id)"
                matListItemMeta>
            <mat-icon>create</mat-icon>
        </button>
    </mat-list-item>
</mat-list>
